import { Box } from '@atgfr8/atg-ui-tailwind';
import {
  customerDetailsStore,
  getCustomerData,
  setCustomerDetailsStore,
} from '@mobileStore/customer';
import { useParams } from '@solidjs/router';
import { formatDateOrNull } from '@utils/dateFormat';
import { formatAmount } from '@utils/utils';
import { onMount, Show } from 'solid-js';
import SectionCard from '@mobileComponents/SectionCard';

import { CommentsCard, Contacts, Documents, Ownership } from './components';

const CustomerDetails = () => {
  const params = useParams();
  onMount(async () => {
    try {
      setCustomerDetailsStore('isLoading', true);
      if (
        (customerDetailsStore.customer.id?.toString() ?? '') !==
        (params.id ?? '')
      ) {
        if (params.id) {
          await getCustomerData(params.id);
        }
      }
    } finally {
      setCustomerDetailsStore('isLoading', false);
    }
  });
  return (
    <Box class="bg-[#e1ecf2]">
      <Box class="m-2!">
        <SectionCard
          title={
            <p class="text-[16px]! font-medium truncate w-[300px]">
              {customerDetailsStore.customer.name || ''}
            </p>
          }
        >
          <Box class="p-2!">
            <Show when={customerDetailsStore.customer.status === 'Inactive'}>
              <p class="bg-[#e29292]! text-[#5a0000]! rounded-sm text-center text-[14px]!">
                This Customer is {customerDetailsStore.customer.status}
              </p>
            </Show>
            <Show when={customerDetailsStore.customer.status === 'InReview'}>
              <p class="text-[14px]!">
                This Customer is currently under Credit Review. Response could
                take <strong>UP TO</strong> 24 hours.
              </p>
            </Show>
            <Box class="flex justify-between items-center mb-2">
              <span class="text-[14px]! font-normal! text-[#00000099]">
                Status
              </span>
              <span class="text-[14px]! font-medium!">
                {customerDetailsStore.customer.subStatus
                  ? `${customerDetailsStore.customer.status} - ${customerDetailsStore.customer.subStatus}`
                  : customerDetailsStore.customer.status}
              </span>
            </Box>
            <Box class="flex justify-between items-center mb-2">
              <span class="text-[14px]! font-normal! text-[#00000099]">
                Last Load Date
              </span>
              <span class="text-[14px]! font-medium!">
                {formatDateOrNull(
                  customerDetailsStore.customer.financials?.lastLoadDate ??
                    null,
                )}
              </span>
            </Box>
            <Box class="flex justify-between items-center bg-[#cdefd0]! rounded-sm border border-[#1C6857] p-[12px]! text-[#15803d]!">
              <span class="text-[14px]! font-normal! text-[#00000099]">
                Credit
              </span>
              <span class="text-[14px]! font-medium!">
                {formatAmount(
                  customerDetailsStore.customer.financials?.availableCredit ||
                    0,
                )}{' '}
                /{formatAmount(customerDetailsStore.customer.creditLimit || 0)}
              </span>
            </Box>
          </Box>
        </SectionCard>

        <Ownership />
        <Contacts />
        <Documents />
        <CommentsCard
          comments={customerDetailsStore.customer.comments}
          type="Customer"
        />
      </Box>
    </Box>
  );
};

export default CustomerDetails;
